import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import { usePopup } from '@collab/features/popup';

import { title } from 'features/test-access-tokens/AccessTokenModal';
import { AuthModalConfig } from 'libs/auth/useAuthProtected';
import { AccessTokenWithTitle } from 'libs/volvoId/models';

import { ApiOption } from '../test-access-tokens.types';
import ApiSelect from './ApiSelect';

const AccessTokenModal = dynamic(
  () => import('features/test-access-tokens/AccessTokenModal'),
);

type GenerateAccessTokenProps = {
  token: AccessTokenWithTitle | null;
  tokenName: string;
  isGenerating: boolean;
  apiOptions: ApiOption[];
  generateButtonText: string;
  authProtectedConfig?: AuthModalConfig;
  onCloseModal: () => void;
  onGenerate: (apiId: string) => void;
};

const GenerateAccessToken: React.FC<GenerateAccessTokenProps> = ({
  token,
  tokenName,
  generateButtonText,
  apiOptions,
  isGenerating,
  authProtectedConfig,
  onCloseModal,
  onGenerate,
}) => {
  const { openPopup, closePopup } = usePopup();

  useEffect(() => {
    if (token) {
      openPopup({
        title,
        components: (
          <AccessTokenModal
            tokenName={tokenName}
            token={token.token}
            onClose={() => {
              onCloseModal();
              closePopup();
            }}
            apiDisplayName={token.apiDisplayName}
          />
        ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <ApiSelect
      buttonText={generateButtonText}
      options={apiOptions}
      onGenerate={onGenerate}
      isLoading={isGenerating}
      authProtectedConfig={
        authProtectedConfig ? authProtectedConfig : undefined
      }
    />
  );
};

export default GenerateAccessToken;
